import { text } from '@piconetworks/remote-markdown'

export default text
